import { gql } from '@apollo/client';

export const DELETE_PROPERTY = gql`
  mutation deleteProperty($propertyId: Int!) {
    deleteProperty(propertyId: $propertyId) {
      commandId
    }
  }
`;
